import Skeleton from 'components/_UI/Skeleton'
import React from 'react'
import styled from 'styled-components'
import { Column } from 'styled/alignment/Column'

export default function EventCardSkeleton() {
    return (
        <Container>
            <ImageSkeleton />
            <Skeleton height="16px" style={{ marginTop: '10px' }} />
            <Skeleton height="13px" width="75%" style={{ marginTop: '6px' }} />
            <Skeleton height="13px" width="60%" style={{ marginTop: '4px' }} />
        </Container>
    )
}

const Container = styled(Column)`
    width: 100%;
`;

const ImageSkeleton = styled.div`
    width: 100%;
    aspect-ratio: 3 / 2;
    border-radius: 12px;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: wave 2.5s infinite linear;

    @keyframes wave {
        0% { background-position: -200px 0; }
        100% { background-position: calc(200px + 100%) 0; }
    }
`;
